export enum FollowUpCertificateModalOption {
  REJECT = 'reject',
  UPDATE_VALIDITY = 'updateValidity',
  UPDATE_FIELDS = 'updateFields',
}
